export interface Tomo {
  numero: string
  titulo: string
  descripcion: string
}

export const tomos: Tomo[] = [
  {
    numero: '01',
    titulo: 'Identidad, autoestima y adolescencia',
    descripcion:
      'Trabajá identidad, autoconocimiento, autoestima y los desafíos propios de la adolescencia.',
  },
  {
    numero: '02',
    titulo: 'Vínculos, afectividad y consentimiento',
    descripcion:
      'Recursos para trabajar vínculos, emociones, afectividad, consentimiento y relaciones saludables.',
  },
  {
    numero: '03',
    titulo: 'Violencias, bullying y prevención',
    descripcion:
      'Actividades para abordar violencia, bullying, prevención, conflictos y situaciones de riesgo.',
  },
  {
    numero: '04',
    titulo: 'Diversidad, derechos y convivencia',
    descripcion:
      'Propuestas para trabajar diversidad, derechos, respeto, inclusión y convivencia.',
  },
  {
    numero: '05',
    titulo: 'Ciudadanía digital, redes sociales e internet',
    descripcion:
      'Recursos para abordar redes sociales, exposición, privacidad, identidad digital y los desafíos del mundo online.',
  },
  {
    numero: '06',
    titulo: 'Salud mental y bienestar',
    descripcion:
      'Actividades para hablar sobre emociones, bienestar, autocuidado y diferentes desafíos relacionados con la salud mental.',
  },
  {
    numero: '07',
    titulo: 'Proyecto de vida, decisiones y futuro',
    descripcion:
      'Propuestas para acompañar a los adolescentes en la toma de decisiones, metas, proyectos personales y construcción de futuro.',
  },
]
